import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { TamasAlunoService } from '../tamas-aluno.service';
import * as moment from 'moment';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { AlertaSimplesDialog } from '../alerta-simples';
import { MatTabChangeEvent } from '@angular/material';

//import {CdkDragDrop, moveItemInArray} from '@angular/cdk/drag-drop';


@Component({
  selector: 'app-perfil-detalhes',
  templateUrl: './perfil-detalhes.component.html',
  styleUrls: ['./perfil-detalhes.component.css']
})
export class PerfilDetalhesComponent implements OnInit, OnDestroy {
  hideCL: boolean = false;
  titEdit: any = '';
  tipoDetalhe: any = '';
  txtDetalhe: any = '';
  perfilNomeUsuario: any = '';
  arrProf: any[] = [];
  arrLoc: any[] = [];
  urlFoto: any = '';
  canEdit: boolean = false;
  arrModalidades: any[] = [];
  arrConquistas: any[] = [];
  arrTitulos: any[] = [];
  arrTorcendo: any[] = [];
  arrTorcedores: any[] = [];
  indexTorcendo: any = 0;
  indexTorcedores: any = 0;
  loadMoreTD: boolean = true;
  loadMoreTS: boolean = true;
  qtyTD: any = 0;
  qtyTS: any = 0;
  tabIndex: any = 0;
  backB: boolean = false;
  constructor(private route: ActivatedRoute, private _location: Location, public router: Router, public tmaService: TamasAlunoService, public dialog: MatDialog) { }


  ngOnInit() {
    this.backB = false;
    this.tmaService.eventoFS(true);
    this.hideCL = false;
    this.tipoDetalhe = this.route.snapshot.paramMap.get('itemlistar');
    this.perfilNomeUsuario = this.route.snapshot.paramMap.get('nomeusuario');

    if (this.tipoDetalhe != 'network') {
      this.listarDadosComp(this.perfilNomeUsuario, this.tipoDetalhe);
    }
    else {
      if (this.tmaService.tempPerfilRS == this.perfilNomeUsuario) {
        if (this.tmaService.tempTorcendo.length > 0 || this.tmaService.tempTorcedores.length > 0) {
          this.listarTT();
        }
        else {
          this.listarNetwork('todos');
        }
      }
      else {

        this.listarNetwork('todos');
      }


      if (this.tmaService.visualTT == 'torcendo') {
        this.tabIndex = 1;
      }
      if (this.tmaService.visualTT == 'torcedores') {
        this.tabIndex = 0;
      }
    }

    if (this.perfilNomeUsuario == this.tmaService.hcNomeUsuario) {
      this.canEdit = true;
    }

  }
  ngOnDestroy() {
    this.tmaService.eventoFS(false);
    if (!this.backB) {
      this.verificarView();
    }

  }

  verificarView(): void {
    if (this.tmaService.gArrUrlPrev.length > 0) {
      var meuIndex = this.tmaService.gArrUrlPrev.findIndex(x => x.destino == "/" + this.perfilNomeUsuario);
      if (meuIndex == this.tmaService.gArrUrlPrev.length - 1) {
        //ok sou o ultimo
      }
      else {
        this.tmaService.gArrUrlPrev.length = meuIndex;
      }
      // if(this.tmaService.gArrUrlPrev[this.tmaService.gArrUrlPrev.length - 1].destino.toString().indexOf(this.perfilNomeUsuario) != -1){
      //     console.log("just pop");
      //     this.tmaService.gArrUrlPrev.pop();
      // }
    }
  }

  changeTab(tabChangeEvent: MatTabChangeEvent): void {
    console.log(tabChangeEvent.index);
    if (tabChangeEvent.index == 0) {
      this.tmaService.visualTT = 'torcedores'
    }
    else {
      this.tmaService.visualTT = 'torcendo';
    }
  }

  listarDadosComp(qUsuario: any, qTipoDetail): void {
    //parte do servidor
    //tipo pode ser modalidades, conquistas, locais , profissionais
    //quando tiver dados mto extensos, usar o index e tal
    var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&usuario=' + qUsuario + '&tipodado=' + qTipoDetail + '&meuindex=0';
    this.tmaService.listarDadosPerfil(dadosIn)
      .subscribe((qRes) => {
        console.log(qRes);
        this.txtDetalhe = this.tipoDetalhe;
        if (qRes['res'] == 'done') {
          if (qTipoDetail == 'profissionais') {
            this.arrProf = qRes['arrResultado'];
            this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
          }
          if (qTipoDetail == 'locais') {
            this.arrLoc = qRes['arrResultado'];
            this.urlFoto = this.tmaService.urlRepositorioS3 + "/local-logos/";
          }
          if (qTipoDetail == 'modalidades') {
            this.arrModalidades = qRes['arrResultado'];
            this.tmaService.mModalidades = qRes['arrResultado'];
            this.tmaService.mModLoaded = true;
            this.urlFoto = this.tmaService.urlRepositorioS3 + "/modalidades/";
          }
          if (qTipoDetail == 'conquistas') {
            this.arrConquistas = qRes['arrResultado'];
            this.arrConquistas.forEach((item, index) => {
              this.arrConquistas[index].data = moment(item.data).format('DD/MM/YYYY');
            });
            this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-conquest/";
          }
          if (qTipoDetail == 'titulos') {
            this.arrTitulos = qRes['arrResultado'];
            this.txtDetalhe = 'Títulos';
            // this.arrConquistas.forEach((item, index) => {
            //   this.arrConquistas[index].data = moment(item.data).format('DD/MM/YYYY');
            // });
            this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-academy/";
          }
        }
        this.hideCL = true;
      })

  }

  listarNetwork(tipobusca: any): void {

    this.tmaService.tempPerfilRS = this.perfilNomeUsuario;
    var indexBuscar = 0;

    if (tipobusca == 'torcendo') indexBuscar = this.indexTorcendo;
    if (tipobusca == 'torcedores') indexBuscar = this.indexTorcedores;

    this.hideCL = false;
    let customParams = {
      //lista: localStorage.getItem('turboCart'),
      email: this.tmaService.hcEmail,
      senha: this.tmaService.hcSenha,
      meuindex: indexBuscar,
      nomeusuario: this.perfilNomeUsuario,
      tipo: tipobusca
    };
    this.tmaService.listarNetWork(customParams).subscribe((qRes) => {
      this.hideCL = true;
      console.log(qRes);
      if (qRes['res'] == 'done') {
        if (tipobusca == 'todos') {
          this.arrTorcendo = this.arrTorcendo.concat(qRes['arrEuSigo']);
          this.arrTorcedores = this.arrTorcedores.concat(qRes['arrMesegue']);
          this.indexTorcedores += qRes['arrMesegue'].length;
          this.indexTorcendo += qRes['arrEuSigo'].length;
          this.tmaService.tempIdxTs = this.indexTorcedores;
          this.tmaService.tempTorcedores = this.arrTorcedores;
          this.tmaService.tempIdxTo = this.indexTorcendo;
          this.tmaService.tempTorcendo = this.arrTorcendo;

          this.qtyTD = qRes['qtdSigo'];
          this.qtyTS = qRes['qtdSegue'];

          this.tmaService.tempQtyTo = this.qtyTD;
          this.tmaService.tempQtyTs = this.qtyTS;

          if (qRes['arrEuSigo'].length < 10) {
            this.loadMoreTD = false;
          }
          if (qRes['arrMesegue'].length < 10) {
            this.loadMoreTS = false;
          }
        }

        if (tipobusca == 'torcedores') {
          this.arrTorcedores = this.arrTorcedores.concat(qRes['arrMesegue']);
          this.indexTorcedores += qRes['arrMesegue'].length;
          this.tmaService.tempIdxTs = this.indexTorcedores;
          this.tmaService.tempTorcedores = this.arrTorcedores;
          if (qRes['arrMesegue'].length < 10) {
            this.loadMoreTS = false;
          }
        }

        if (tipobusca == 'torcendo') {
          this.arrTorcendo = this.arrTorcendo.concat(qRes['arrEuSigo']);
          this.indexTorcendo += qRes['arrEuSigo'].length;
          this.tmaService.tempIdxTo = this.indexTorcendo;
          this.tmaService.tempTorcendo = this.arrTorcendo;
          if (qRes['arrEuSigo'].length < 10) {
            this.loadMoreTD = false;
          }
        }



        this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
      }
      else {
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Ocorreu um erro ao realizar esta operação Tente novamente", iconAlerta: 'warning' }
        })
      }
    },
      (error) => {
        this.hideCL = true;
        const erroCriar = this.dialog.open(AlertaSimplesDialog, {
          disableClose: true,
          data: { tituloAlerta: "Aviso", textoAlerta: "Verifique sua conexão com a internet. Tente novamente", iconAlerta: 'warning' }
        });
      })

  }

  //chamar isso se já tiver sido carregado torcedores antes
  listarTT(): void {
    this.hideCL = true;
    this.arrTorcendo = this.tmaService.tempTorcendo
    this.arrTorcedores = this.tmaService.tempTorcedores
    this.indexTorcedores += this.tmaService.tempIdxTs
    this.indexTorcendo += this.tmaService.tempIdxTo;
    this.qtyTD = this.tmaService.tempQtyTo
    this.qtyTS = this.tmaService.tempQtyTs;
    this.urlFoto = this.tmaService.urlRepositorioS3 + "/users-profile-picture/";
    this.loadMoreTD = true;
    this.loadMoreTS = true;

    setTimeout(() => {
      if (this.tmaService.tempContatoPos != 0) {
        if (this.tmaService.visualTT == 'torcendo') {
          document.querySelector('#to_' + this.tmaService.tempContatoPos).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
        else {
          document.querySelector('#ts_' + this.tmaService.tempContatoPos).scrollIntoView({ behavior: 'smooth', block: 'start' });
        }

      }
    }, 500);
  }


  goPoL(urlAmigavel: any): void {

    if (this.tipoDetalhe == 'profissionais') {
      this.tmaService.paginaAnterior = this.router.url;
      this.router.navigate(['/' + urlAmigavel]);
    }
    else {
      this.tmaService.paginaAnterior = this.router.url;
      this.router.navigate(['/local/' + urlAmigavel]);
    }
  }

  goInserir(qTipo: any): void {
    if (this.canEdit) {
      this.router.navigate(['/' + this.perfilNomeUsuario + '/add/' + qTipo]);
    }

  }


  goPerfil(nomeUser: any, index: any): void {

    this.backB = true;
    // if(this.tmaService.gUrlPerfilPai == ''){
    //   this.tmaService.gUrlPerfilPai = "/" + nomeUser;
    // }

    //defino o meu
    if (this.tmaService.gArrUrlPrev.length == 0) {
      this.tmaService.gArrUrlPrev.push({ destino: "/" + this.perfilNomeUsuario });
      //defino o prox
      if (this.tmaService.gArrUrlPrev.findIndex(x => x.destino == "/" + nomeUser) == -1) {
        this.tmaService.gArrUrlPrev.push({ destino: "/" + nomeUser });
      }
    }
    else {
      //já existe
      var qIndex = this.tmaService.gArrUrlPrev.findIndex(x => x.destino == "/" + this.perfilNomeUsuario)
      if (qIndex == this.tmaService.gArrUrlPrev.length - 1) {
        //ok sou o ultimo
      }
      else {
        this.tmaService.gArrUrlPrev.length = qIndex + 1;
      }
      //defino o prox
      if (this.tmaService.gArrUrlPrev.findIndex(x => x.destino == "/" + nomeUser) == -1) {
        this.tmaService.gArrUrlPrev.push({ destino: "/" + nomeUser });
      }

    }


    this.tmaService.tempContatoPos = index;
    this.tmaService.gUrlAnterior = this.router.url;
    this.router.navigate(['/' + nomeUser]);
  }


  excluirModal(idModalidade: any): void {
    if (this.canEdit) {
      this.hideCL = false;
      console.log(idModalidade);
      var dadosIn = 'email=' + this.tmaService.hcEmail + '&senha=' + this.tmaService.hcSenha + '&idmodal=' + idModalidade;
      this.tmaService.removeModalidade(dadosIn)
        .subscribe((qRes) => {
          console.log(qRes);
          if (qRes['res'] == 'done') {
            var idxMod = this.arrModalidades.findIndex(x => x.id == idModalidade);
            this.arrModalidades.splice(idxMod, 1);
            this.hideCL = true;
          }
        });
    }
  }
  moreInfo(idconquista: any): void {
    //posibilidade de clicar na conquista e carregar uma bottomsheet com as infos e foto e tal
    //tbm ter um link para a "postagem", dessa forma ele pode compartilhar diretamente o link 
    //item id
    this.router.navigate(['/' + this.perfilNomeUsuario + '/' + this.tipoDetalhe + '/' + idconquista]);
  }

  voltar(): void {
    this.backB = true;
    this.tmaService.visualTT = '';
    //this._location.back();
    this.router.navigate(['/' + this.route.snapshot.paramMap.get('nomeusuario')]);
    // if(this.tmaService.gUrlAnterior != ''){
    //   this.router.navigate([ this.tmaService.gUrlAnterior]);
    // }
    // else{
    //   this.router.navigate(['/' + this.route.snapshot.paramMap.get('nomeusuario')]);
    // }

  }

}
